/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_Previous_AriaInputs */



/**
* | output |
* | --- |
* | "Previous Event" |
*
* @param {Video_Export_Preview_Previous_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_previous_aria = /** @type {((inputs?: Video_Export_Preview_Previous_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_Previous_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Evenement precedent")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorheriges Ereignis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Evento precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предыдущее событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Evento anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("上一活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("前回のイベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछला कार्यक्रम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Evento anterior")
	return /** @type {LocalizedString} */ ("Previous Event")
});